import { render, staticRenderFns } from "./icon-close.vue?vue&type=template&id=0eebdb12"
import script from "./icon-close.vue?vue&type=script&lang=ts"
export * from "./icon-close.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports